import { queryClient, apiRequest } from "../lib/queryClient";

const passwordKey = "pasword";

export function useChangePassword(options = {}) {
 

 


  const changePassword = async (pageData) => {
    const response = await apiRequest("/auth/change-password", {
      method: "POST",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [passwordKey] });
    return response;
  };

 

  

  return {
    changePassword,
  };
}
